export function addPxSuffix (str: string | number): string {
  // 处理数字类型：直接拼接px
  if (typeof str === 'number') {
    return `${str}px`;
  }
  // 处理字符串类型
  const trimmedStr = str.trim();
  // 检查是否已以px结尾（不区分大小写）
  if (/px$/i.test(trimmedStr)) {
    return str; // 已包含px，直接返回原字符串
  }
  // 非px结尾的字符串，拼接px
  return `${trimmedStr}px`;
}
